var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manageWrapper" },
    [
      _c("div", { staticClass: "search-container pb-0" }, [
        _c(
          "div",
          {
            staticClass:
              "manage-header d-flex align-items-center justify-content-between"
          },
          [
            _c("div", { staticClass: "w-50 d-flex align-items-center" }, [
              _c("span", { staticClass: "title" }, [_vm._v("Plan")]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "item ml-2" },
                [
                  _c("multiselect", {
                    staticClass: "content",
                    attrs: {
                      options: _vm.programClientList,
                      placeholder: _vm.programClientList
                        ? _vm.programClientSelected.name
                        : "Empty",
                      label: "name",
                      openDirection: "below",
                      multiple: false,
                      "close-on-select": true,
                      "hide-selected": true,
                      "track-by": "name",
                      "allow-empty": true,
                      "show-labels": false
                    },
                    on: { select: _vm.selectProgramItemClick },
                    model: {
                      value: _vm.programClientSelected,
                      callback: function($$v) {
                        _vm.programClientSelected = $$v
                      },
                      expression: "programClientSelected"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "item ml-2" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Program Operation Date:")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "label content" }, [
                  _vm._v(_vm._s(_vm.programDate))
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "ml-5",
                    attrs: { disabled: _vm.isDownloading },
                    on: {
                      click: function($event) {
                        _vm.exportParticipantReport(
                          _vm.programClientSelected.id
                        )
                      }
                    }
                  },
                  [
                    _c("span", [_vm._v("Download Participant Report")]),
                    _vm._v(" "),
                    _vm.isDownloading
                      ? _c("b-spinner", {
                          staticClass: "ml-1",
                          attrs: { small: "" }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "ml-3",
                    on: { click: _vm.onManageClientSettings }
                  },
                  [_vm._v("\n          Manage Client Settings\n        ")]
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-4" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("p", { staticClass: "text-manage-events" }, [
              _vm._v(_vm._s(_vm.consts.planMessage[_vm.tableType]))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-4" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("ul", { staticClass: "status-menu pl-0" }, [
              _c(
                "li",
                {
                  staticClass: "status-menu-item",
                  class:
                    _vm.tableType === _vm.consts.eventStatus.drafts
                      ? "selected"
                      : null,
                  on: {
                    click: function($event) {
                      _vm.tableType = _vm.consts.eventStatus.drafts
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            drafts - " +
                      _vm._s(_vm.totalDrafts) +
                      "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "status-menu-item",
                  class:
                    _vm.tableType === _vm.consts.eventStatus.approved
                      ? "selected"
                      : null,
                  on: {
                    click: function($event) {
                      _vm.tableType = _vm.consts.eventStatus.approved
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            approved - " +
                      _vm._s(_vm.totalApproved) +
                      "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "status-menu-item",
                  class:
                    _vm.tableType === _vm.consts.eventStatus.archived
                      ? "selected"
                      : null,
                  on: {
                    click: function($event) {
                      _vm.tableType = _vm.consts.eventStatus.archived
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            archived - " +
                      _vm._s(_vm.totalArchived) +
                      "\n          "
                  )
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-events" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _vm.enableSelectEvents
              ? _c("div", { staticClass: "select-event-text" }, [
                  _c("span", [
                    _vm._v(
                      "Select multiple " +
                        _vm._s(_vm.tableType) +
                        " events to submit"
                    )
                  ])
                ])
              : _c("div", { staticClass: "grp-button-action" }, [
                  _vm.tableType === _vm.consts.eventStatus.drafts
                    ? _c(
                        "button",
                        {
                          staticClass: "item-create-btn ap-btn primary",
                          attrs: { type: "button", disabled: _vm.getLoading },
                          on: {
                            click: function($event) {
                              _vm.btnAddClick()
                            }
                          }
                        },
                        [_vm._v("Create\n          ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tableType === _vm.consts.eventStatus.drafts
                    ? _c(
                        "button",
                        {
                          staticClass: "item-submit-btn ap-btn secondary",
                          attrs: {
                            type: "button",
                            disabled:
                              _vm.getLoading || _vm.getListEvent.length === 0
                          },
                          on: { click: _vm.onShowSubmitAll }
                        },
                        [_vm._v("\n            Submit All\n          ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "item-submit-btn ap-btn secondary",
                      attrs: {
                        type: "button",
                        disabled:
                          _vm.getLoading || _vm.getListEvent.length === 0
                      },
                      on: { click: _vm.onShowSelectEvents }
                    },
                    [_vm._v("\n            Select Events\n          ")]
                  ),
                  _vm._v(" "),
                  _vm.tableType === _vm.consts.eventStatus.drafts
                    ? _c(
                        "button",
                        {
                          staticClass: "item-submit-btn ap-btn secondary",
                          attrs: { type: "button", disabled: _vm.getLoading },
                          on: { click: _vm.onShowBulkEvents }
                        },
                        [_vm._v("\n            Bulk Create Events\n          ")]
                      )
                    : _vm._e()
                ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list-header mt-4" }, [
          _vm.enableSelectEvents
            ? _c("div", { staticClass: "column w-2" })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "column w-14" }, [
            _c(
              "div",
              { staticClass: "container-column border-seperate" },
              [
                _c("p", { staticClass: "text-header" }, [_vm._v("Event Date")]),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    on: {
                      click: function($event) {
                        _vm.onSort("dateTime")
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../../../static/img/arrow-down.svg"),
                        alt: "icon"
                      }
                    })
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "column w-14" }, [
            _c(
              "div",
              { staticClass: "container-column justify-content-between" },
              [
                _c("p", { staticClass: "text-header" }, [_vm._v("Duplicate")]),
                _vm._v(" "),
                _c("p", { staticClass: "text-header" }, [
                  _vm.tableType === _vm.consts.eventStatus.drafts
                    ? _c("span", [_vm._v("Delete")])
                    : _c("span", [_vm._v("Status")])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-header" }, [_vm._v("Details")])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _vm.loadingList
          ? _c(
              "div",
              { staticClass: "list-loading d-flex justify-content-center" },
              [
                _c("b-spinner", {
                  attrs: { variant: "primary", label: "Spinning" }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.loadingList
          ? _c(
              "div",
              [
                _vm._l(_vm.events, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "list-container" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "list-content",
                          attrs: { for: "select-event-check-" + index }
                        },
                        [
                          _vm.enableSelectEvents
                            ? _c("div", { staticClass: "column w-2" }, [
                                _c("div", { staticClass: "container-column" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedEvents,
                                        expression: "selectedEvents"
                                      }
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      id: "select-event-check-" + index
                                    },
                                    domProps: {
                                      value: item,
                                      checked: Array.isArray(_vm.selectedEvents)
                                        ? _vm._i(_vm.selectedEvents, item) > -1
                                        : _vm.selectedEvents
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.selectedEvents,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = item,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.selectedEvents = $$a.concat([
                                                $$v
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.selectedEvents = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.selectedEvents = $$c
                                        }
                                      }
                                    }
                                  })
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "column w-14" }, [
                            _c(
                              "div",
                              {
                                staticClass: "container-column border-seperate"
                              },
                              [_c("p", [_vm._v(_vm._s(item.prefDate))])]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "column w-14" }, [
                            _c(
                              "div",
                              {
                                staticClass: "container-column border-seperate"
                              },
                              [_c("p", [_vm._v(_vm._s(item.eventName))])]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "column w-14" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "container-column border-seperate proj-part"
                              },
                              [_c("p", [_vm._v(_vm._s(item.projPart))])]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "column w-14" }, [
                            _c(
                              "div",
                              {
                                staticClass: "container-column border-seperate"
                              },
                              [_c("p", [_vm._v(_vm._s(item.fullAddress))])]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "column w-14" }, [
                            _c(
                              "div",
                              {
                                staticClass: "container-column border-seperate"
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(item.startTime + "-" + item.endTime)
                                  )
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "column w-14" }, [
                            _c(
                              "div",
                              {
                                staticClass: "container-column border-seperate"
                              },
                              [_c("p", [_vm._v(_vm._s(item.contactName))])]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "column w-14" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "container-column justify-content-between"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "button-view" },
                                  [
                                    _c("b-button", {
                                      staticClass: "btn-duplicate",
                                      on: {
                                        click: function($event) {
                                          _vm.onShowDuplicatePopup(item)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "button-view" },
                                  [
                                    _vm.tableType ===
                                    _vm.consts.eventStatus.drafts
                                      ? [
                                          _c("b-button", {
                                            staticClass: "btn-delete",
                                            on: {
                                              click: function($event) {
                                                _vm.onDelete(item)
                                              }
                                            }
                                          })
                                        ]
                                      : [
                                          _c("div", [
                                            item.status === "ARCHIVED"
                                              ? _c(
                                                  "div",
                                                  [
                                                    _c("b-button", {
                                                      staticClass: "btn-status",
                                                      attrs: {
                                                        disabled:
                                                          _vm.userRole !==
                                                          _vm.consts.USER_ROLE
                                                            .admin
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.onStatus(item)
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "b-dropdown",
                                                      {
                                                        staticClass:
                                                          "btn-status btn-status-dropdown",
                                                        attrs: {
                                                          disabled:
                                                            _vm.userRole !==
                                                            _vm.consts.USER_ROLE
                                                              .admin
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "b-dropdown-item",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.showApprovedToArchivedPopup(
                                                                  item
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Move to Archived Status"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-dropdown-item",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.showApprovedToDraftsPopup(
                                                                  item
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Move to Draft Status"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                          ])
                                        ]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "button-view" },
                                  [
                                    _c("b-button", {
                                      staticClass: "btn-expand",
                                      on: {
                                        click: function($event) {
                                          _vm.onDetails(item)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "load-more" },
                  [
                    _c("b-spinner", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loadMoreLoading,
                          expression: "loadMoreLoading"
                        }
                      ],
                      attrs: { variant: "primary", label: "Spinning" }
                    })
                  ],
                  1
                )
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.enableSelectEvents
        ? _c("div", { staticClass: "footer" }, [
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "item-submit-btn ap-btn secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.onCancelSelectEvents }
                },
                [_vm._v("\n        Cancel\n      ")]
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.selectedEvents.length) +
                    " " +
                    _vm._s(
                      _vm.selectedEvents.length === 1 ? "event" : "events"
                    ) +
                    " selected"
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "item-create-btn ap-btn primary",
                  attrs: {
                    type: "button",
                    disabled: !_vm.selectedEvents.length
                  },
                  on: { click: _vm.onShowSubmitEvents }
                },
                [_vm._v("\n        Submit\n      ")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Popup",
        {
          attrs: {
            name: "submitAllPopup",
            "cancel-text": "Cancel",
            "submit-text": "Submit"
          },
          on: { onSubmit: _vm.onSubmitAll }
        },
        [
          _c("template", { slot: "header" }, [
            _vm._v("Are you sure you want to submit your drafts?")
          ]),
          _vm._v(" "),
          _c("template", { slot: "body" }, [
            _vm._v("You are submitting "),
            _c("strong", [
              _vm._v(
                _vm._s(_vm.totalDrafts) +
                  " " +
                  _vm._s(_vm.totalDrafts === 1 ? "record" : "records")
              )
            ]),
            _vm._v(
              ".  You can manage the events in the ‘Manage’ section of your dashboard after events are submitted."
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "Popup",
        {
          attrs: {
            name: "submitEventsPopup",
            "cancel-text": "Cancel",
            "submit-text": "Submit"
          },
          on: { onSubmit: _vm.onSubmitEvents }
        },
        [
          _c("template", { slot: "header" }, [
            _vm._v(
              "Are you sure you want to submit your " +
                _vm._s(_vm.tableType) +
                "?"
            )
          ]),
          _vm._v(" "),
          _c("template", { slot: "body" }, [
            _vm._v("You are submitting "),
            _c("strong", [
              _vm._v(
                _vm._s(_vm.selectedEvents.length) +
                  " " +
                  _vm._s(_vm.selectedEvents.length === 1 ? "record" : "records")
              )
            ]),
            _vm._v(
              ".  You can manage the events in the ‘Manage’ section of your dashboard after events are submitted."
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "Popup",
        {
          attrs: {
            name: "duplicatePopup",
            "cancel-text": "Cancel",
            "submit-text": "Submit"
          },
          on: { onSubmit: _vm.onDuplicate }
        },
        [
          _c("template", { slot: "header" }, [
            _vm._v("Are you sure you want to duplicate the selected events?")
          ]),
          _vm._v(" "),
          _c("template", { slot: "body" }, [
            _vm._v("You are submitting "),
            _c("strong", [
              _vm._v(
                _vm._s(_vm.selectedEvents.length) +
                  " " +
                  _vm._s(_vm.selectedEvents.length === 1 ? "record" : "records")
              )
            ]),
            _vm._v(
              ". Events will be created in draft status. You can manage the events in the ”draft” tab after duplicates are created."
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "Popup",
        {
          attrs: {
            name: "moveToApprovedPopup",
            "cancel-text": "Cancel",
            "submit-text": "Submit"
          },
          on: {
            onSubmit: function($event) {
              _vm.onChangeStatus(_vm.consts.eventStatus.approved.toUpperCase())
            }
          }
        },
        [
          _c("template", { slot: "header" }, [
            _vm._v(
              "Are you sure you want to change the selected event from Archived status back to Approved status？"
            )
          ]),
          _vm._v(" "),
          _c("template", { slot: "body" }, [
            _vm._v("Event will be moved to Approved tab after submission.")
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "Popup",
        {
          attrs: {
            name: "moveApprovedToDraftsPopup",
            "cancel-text": "Cancel",
            "submit-text": "Submit"
          },
          on: {
            onSubmit: function($event) {
              _vm.onChangeStatus(_vm.consts.eventStatus.drafts.toUpperCase())
            }
          }
        },
        [
          _c("template", { slot: "header" }, [
            _vm._v("Are you sure you want to change the selected event from "),
            _c("u", [_vm._v("Approved")]),
            _vm._v(" status back to "),
            _c("u", [_vm._v("Draft")]),
            _vm._v(" status ?")
          ]),
          _vm._v(" "),
          _c("template", { slot: "body" }, [
            _vm._v("Event will be moved to draft tab after submission.")
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "Popup",
        {
          attrs: {
            name: "moveApprovedToArchivedPopup",
            "cancel-text": "Cancel",
            "submit-text": "Submit"
          },
          on: {
            onSubmit: function($event) {
              _vm.onChangeStatus(_vm.consts.eventStatus.archived.toUpperCase())
            }
          }
        },
        [
          _c("template", { slot: "header" }, [
            _vm._v("Are you sure you want to change the selected event from "),
            _c("u", [_vm._v("Approved")]),
            _vm._v(" status to "),
            _c("u", [_vm._v("Archived")]),
            _vm._v(" status ?")
          ]),
          _vm._v(" "),
          _c("template", { slot: "body" }, [
            _vm._v(
              "Event will be moved to Archived tab after submission. Archived events are not editable."
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column w-14" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Event Name")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column w-14" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Participant")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column w-14" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Event Address")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column w-14" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Time")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column w-14" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Onsite Contact")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-64bfa673", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64bfa673","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eventManagement/main/Plan.vue
// module id = 1965
// module chunks = 1